import { render } from "./layout.vue?vue&type=template&id=fd874150&ts=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__